
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/coins",
      function () {
        return require("private-next-pages/store/coins/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/coins"])
      });
    }
  